export const ModelTiers = {
    STANDARD: 'Standard',
    PRECISION: 'Precision',
    CUSTOM: 'Custom'
};